import { useEffect } from 'react';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';
import { getSlideNumberInType } from './slide-helpers';
import { EMAIL_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PRODUCT_SLIDE, PROFILE_SLIDE, NAME_SLIDE, PRESALE_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_MULTI_ANSWER_SLIDE_COMPONENT, QUESTION_SCALE_SLIDE_COMPONENT, RESULT_SLIDE, REVIEW_SLIDE, START_SLIDE } from './quiz-component-types';

const QUESTION_NUMBER_1 = 1;
const QUESTION_COMPONENTS = [QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_MULTI_ANSWER_SLIDE_COMPONENT, QUESTION_SCALE_SLIDE_COMPONENT];

function useSlideEventsV3({ currentSlideIndex, currentSlide, quizSlides = [] }) {
    useEffect(() => {
        logEvent(EVENT_TYPES.QUIZ_PAGE_VISITED);
    }, []);

    useEffect(() => {
        const questionSlides = quizSlides.filter(slide => QUESTION_COMPONENTS.includes(slide.component));
        const questionNumber = questionSlides.indexOf(currentSlide) + 1;

        if (questionNumber) {
            logEvent(EVENT_TYPES.QUIZ_QUESTION_VISITED, { questionNumber });
        }
    }, [currentSlide.id]);

    useEffect(() => {
        if (currentSlide.component === START_SLIDE) {
            logEvent(EVENT_TYPES.START_PAGE_VISITED);
        }

        if (currentSlide.component === PAUSE_SLIDE) {
            logEvent(EVENT_TYPES.PAUSE_PAGE_VISITED, { pauseNumber: getSlideNumberInType(quizSlides, currentSlide) });
        }

        if (currentSlide.component === PRODUCT_SLIDE) {
            logEvent(EVENT_TYPES.PRODUCT_PAGE_VISITED, { productNumber: getSlideNumberInType(quizSlides, currentSlide) });
        }

        if (currentSlide.component === PLAN_GRAPH_SLIDE) {
            logEvent(EVENT_TYPES.PLAN_GRAPH_PAGE_VISITED);
        }

        if (currentSlide.component === REVIEW_SLIDE) {
            logEvent(EVENT_TYPES.REVIEW_PAGE_VISITED);
        }

        if (currentSlide.component === PLAN_LOADER_SLIDE) {
            logEvent(EVENT_TYPES.PLAN_LOADER_PAGE_VISITED);
        }

        if (currentSlide.component === EMAIL_SLIDE) {
            logEvent(EVENT_TYPES.EMAIL_PAGE_VISITED);
        }

        if (currentSlide.component === RESULT_SLIDE) {
            logEvent(EVENT_TYPES.RESULT_PAGE_VISITED);
        }

        if (currentSlide.component === PROFILE_SLIDE) {
            logEvent(EVENT_TYPES.PROFILE_PAGE_VISITED);
        }

        if (currentSlide.component === NAME_SLIDE) {
            logEvent(EVENT_TYPES.NAME_PAGE_VISITED);
        }

        if (currentSlide.component === PRESALE_SLIDE) {
            logEvent(EVENT_TYPES.PRESALE_PAGE_VISITED);
        }
    }, [currentSlide.component, currentSlide.id]);

    const logQuizLifecycle = (isLast, firstQuestionAnswer) => {
        if (currentSlide.component === QUESTION_ANSWER_SLIDE_COMPONENT || currentSlide.component === QUESTION_MULTI_ANSWER_SLIDE_COMPONENT || currentSlide.component === QUESTION_SCALE_SLIDE_COMPONENT) {
            if (currentSlideIndex === QUESTION_NUMBER_1) {
                logEvent(EVENT_TYPES.QUIZ_STARTED, firstQuestionAnswer?.text ? { answer: firstQuestionAnswer.text } : undefined);
            }

            if (isLast) {
                logEvent(EVENT_TYPES.QUIZ_COMPLETED);
            }
        }
    };

    return {
        logQuizLifecycle
    };
}

export {
    useSlideEventsV3
};
